export const SCHEDULING_STRATEGY_OPTIONS = [
    {
        value: 'FIRST_AVAILABLE',
        label: 'First available',
        description: 'Pre-fetch the next available slots and present them proactively',
    },
    {
        value: 'OPEN_ENDED',
        label: 'Open ended',
        description: 'Ask the caller for a preferred time, then fetch availability',
    },
];
//# sourceMappingURL=index.js.map